




import { Component, Vue } from 'vue-property-decorator'
import { mapActions } from 'vuex'
import { APP_MODULE, SET_USER_AGENT } from './store/modules/app/constant'
import VConsole from 'vconsole'

@Component({
  methods: {
    ...mapActions(APP_MODULE, [SET_USER_AGENT])
  }
})
export default class App extends Vue {
  setUserAgent!: () => void
  created() {
    if (process.env.VUE_APP_ENABLE_VCONSOLE === 'true') {
      new VConsole({ theme: 'dark' })
    }

    this[SET_USER_AGENT]()
  }
}
